import React, { FC, useEffect, useRef } from 'react';
import { Toast } from 'primereact/toast';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primeicons/primeicons.css';

export type ErrorToastProps = {
  error: string;
}

const ErrorToast: FC<ErrorToastProps> = ({ error }) => {
  const toast = useRef<Toast>(null);

  useEffect(() => {
    toast.current?.show({ severity:'error', detail: error, life: 80000 });
  }, []);

  return (
    <Toast
      pt={{
        detail: { className: 'mt-0' },
        content: { className: 'border-0' },
      }}
      ref={toast}
    />
  );
};

export default ErrorToast;
